import * as React from 'react';

import {Select} from 'shells/select/select';

import type {ReportGap, DateRangeType} from '../report-types';

import styles from './hero-chart-header.module.css';

const GAP_SELECT_VALUES = [
    {value: 'd', label: 'day'},
    {value: 'w', label: 'week'},
    {value: 'm', label: 'month'},
    {value: 'q', label: 'quarter'},
    {value: 'y', label: 'year'},
];

const STATUS_SELECT_VALUES = [
    {value: 'createdTime', label: 'open date'},
    {value: 'closedTime', label: 'closed date'},
];

type Props = {
    dateRangeType: DateRangeType;
    reportGap: ReportGap;
    onTypeChange: (arg1: {value: DateRangeType}) => void;
    onGapChange: (arg1: {value: ReportGap}) => void;
};

export function HeroChartHeader({dateRangeType, reportGap, onTypeChange, onGapChange}: Props) {
    const selectedValue = STATUS_SELECT_VALUES.find((val) => val.value === dateRangeType);

    return (
        <div className={styles['header--hero']}>
            <span>
                <span>Leads by</span>
                <div className={styles.select}>
                    <Select
                        styleOptions={{filled: true}}
                        value={selectedValue}
                        valueKey='value'
                        labelKey='label'
                        selectValues={STATUS_SELECT_VALUES}
                        onChange={onTypeChange}
                    />
                </div>
            </span>
            <span>grouped by</span>
            <div className={styles.select}>
                <Select
                    styleOptions={{filled: true}}
                    value={GAP_SELECT_VALUES.find((val) => val.value === reportGap)}
                    valueKey='value'
                    labelKey='label'
                    selectValues={GAP_SELECT_VALUES}
                    onChange={onGapChange}
                />
            </div>
        </div>
    );
}
